import { render, staticRenderFns } from "./consultation-detail.vue?vue&type=template&id=3505b573&scoped=true&"
import script from "./consultation-detail.vue?vue&type=script&lang=js&"
export * from "./consultation-detail.vue?vue&type=script&lang=js&"
import style0 from "./consultation-detail.vue?vue&type=style&index=0&id=3505b573&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3505b573",
  null
  
)

export default component.exports